import styled from 'styled-components';

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.25rem;
    font-family: Hero New;
    padding-top: 6rem;

    h3 {
        color: var(--Neutral-800, #27272a);
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1.5rem;
    }

    input {
        border-radius: 0.75rem;
        outline: 2px solid var(--Silver-100, #ededed);
        border: none;
        background: var(--Neutral-0, #fff);
        transition: 0.1s;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);

        &:focus {
            outline: 2px solid var(--Silver-100, #ededed);
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
        }
    }
`;

export const CheckoutContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    gap: 1.5rem;
    flex-wrap: nowrap;
    max-height: 100%;

    .column {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;

        width: 100%;
    }

    max-width: 80rem;
    width: 100%;

    @media (max-width: 1300px) {
        & {
            flex-wrap: wrap;
            max-width: 60rem;
        }
    }

    @media (max-width: 800px) {
        & {
        }
    }
`;

export const ItemListCard = styled.div`
    flex: 2;
    border-radius: 1.25rem;
    padding: 0.75rem;

    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
    border-radius: 1.25rem;
    background: var(--Silver-50, #f7f7f7);

    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    overflow-y: auto;

    @media (min-width: 800px) {
        min-width: 50rem;
    }
`;

export const ItemList = styled.div`
    width: 100%;
`;

export const Summary = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    min-width: 25rem;

    @media (max-width: 800px) {
        & {
            width: 100%;
        }
    }
`;

export const Button = styled.button`
    background-color: #ffc107;
    border: none;
    border-radius: 0.5rem;
    padding: 0.9375rem;
    font-size: 1rem;
    cursor: pointer;
    width: 100%;

    &:hover {
        background-color: #e0a800;
    }

    & > strong {
        font-weight: bold;
    }
`;

export const TermText = styled.span`
    text-decoration: underline;
    font-weight: 400;
    line-height: 1.5rem;
    cursor: pointer;
`;
